// extracted by mini-css-extract-plugin
export var callCard = "_re-0";
export var callMessageButton = "_re-1";
export var helpIcon = "_re-3";
export var helpIconContainer = "_re-4";
export var verticalDivider = "_re-2";